export const nonEligibilityReasonCode1 = {
  code: '001',
  title: 'FLIGHT CHANGE NOT ALLOWED'
};

export const nonEligibilityReasonCode2 = {
  code: '002',
  title: 'Refund for this PNR has already been requested'
};

export const nonEligibilityReasonCode3 = {
  code: '003',
  title: 'Not Activated'
};

export const nonEligibilityReasonCode6 = {
  code: '006',
  title: 'No e-tickets eligible for refund were found.'
};

export const nonEligibilityReasonCode8 = {
  code: '008',
  title: 'PNR/TICKET DISCREPANCY'
};

export const nonEligibilityReasonCode11 = {
  code: '011',
  title: 'PASSENGER CHANGE NOT ALLOWED'
};

export const nonEligibilityReasonCode23 = {
  code: '023',
  title: 'SEAT CHANGE NOT ALLOWED'
};

export const nonEligibilityReasonCode24 = {
  code: '024',
  title: 'SERVICE CHANGE NOT ALLOWED'
};

export const nonEligibilityRefundReasonCode24 = {
  code: '024',
  title: 'Voluntary refund not possible on disrupted flights.'
};

export const nonEligibilityReasonCode201 = {
  code: '201',
  title: 'Bound is cancelled or partially cancelled.'
};

export const nonEligibilityReasonCode222 = {
  code: '222',
  title: 'Eligibility rule not found.'
};

export const nonEligibilityReasonCode39408 = {
  code: '39408',
  title: 'Acknowledge functionality is not enabled.'
};

export const nonEligibilityReasonCode50006 = {
  code: '50006',
  title: 'No disruption to acknowledge.'
};

export const nonEligibilityReasonCode65211 = {
  code: '65211',
  title: 'FUNCTIONALITY NOT ENABLED'
};
